import { Component } from "@angular/core";
import {
    NmsWizardStepModel,
    AbstractNmsWizardStep,
    NmsWizardStepMapData,
    NmsWizardStepValidationResponse
} from "@nms-angular-toolkit/nms-wizard";
import { SchedulerListService } from "@nms-ng2/app/modules/scheduler/scheduler-list/scheduler-list.service";
import { BackupDevicesGeneral } from "./backup-general-tab.model";
import { CreateBackupService } from "../../create-backup.service";
import { BackupDevicesScheduler } from "../backup-scheduler-tab/backup-scheduler-tab.model";

/**
 * Aba de configurações gerais do backup.
 */
@Component({
    selector: "backup-general-tab",
    templateUrl: "./backup-general-tab.component.html",
    styleUrls: ["./backup-general-tab.component.scss"]
})
export class BackupGeneralTabComponent extends AbstractNmsWizardStep {
    model: BackupDevicesGeneral = new BackupDevicesGeneral();

    constructor(private schedulerListService: SchedulerListService,
                private createBackupService: CreateBackupService) {
        super();
        this.model.enabled = true;
    }

    async comingFromPreviousStep(backupdevicesScheduler: BackupDevicesScheduler,
                                 wizardStepsCacheMap: NmsWizardStepMapData): Promise<BackupDevicesGeneral> {
        this.model = wizardStepsCacheMap["BackupDevicesGeneral"] as BackupDevicesGeneral || this.model;

        return Promise.resolve(this.model)
    }

    async goingToPreviousStep(): Promise<NmsWizardStepModel> {
        return Promise.resolve(this.model)
    }

    async allowPrevious(): Promise<NmsWizardStepValidationResponse> {
        return Promise.resolve(NmsWizardStepValidationResponse.getDefaultValidationResponse());
    }

    async allowNext(): Promise<NmsWizardStepValidationResponse> {
        return Promise.resolve(NmsWizardStepValidationResponse.getDefaultValidationResponse());
    }

    async finishAction(wizardStepsCacheMap: NmsWizardStepMapData): Promise<void> {
        const schedulerJob = this.createBackupService.buildDeviceBackupScheduler(wizardStepsCacheMap);

        try {
            return this.schedulerListService.save(schedulerJob);
        } finally {
            this.loadingConfig.emit({ showLoading: false });
        }
    }
}
